module.exports = __webpack_public_path__ + "static/img/services2.0c321a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/services2.png
// module id = lyNb
// module chunks = 0